<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_search_placeholder') || '版本编号/版本名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-if="allow('A')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditDialog', { type: 'add' })"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form :model="form" label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_deviceId') || '设备编号'">
              <el-input
                v-model.trim="form.deviceId"
                :placeholder="
                  $l('form_placeholder_deviceId') || '请输入设备编号'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_ip') || 'ip地址'">
              <el-input
                v-model.trim="form.ip"
                :placeholder="$l('form_placeholder_IP') || '请输入ip地址'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_versionNo') || '版本编号'">
              <el-input-number
                v-model="form.versionNo"
                :precision="0"
                :controls="false"
                :max="9999999999"
                :placeholder="
                  $l('form_placeholder_versionNo') || '请输入版本编号'
                "
                :min="0"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_versionName') || '版本名称'">
              <el-input
                v-model.trim="form.versionName"
                :placeholder="
                  $l('form_placeholder_versionName') || '请输入版本名称'
                "
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-row>
              <el-form-item
                :label="$l('form_label_statusTime') || '最后一次状态时间'"
                class="flex-1"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.statusTimeStart"
                    :placeholder="
                      $l('form_placeholder_statusTimeStart') ||
                        '请选择最后一次状态时间'
                    "
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetime"
                    clearable
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.statusTimeEnd"
                    :placeholder="
                      $l('form_placeholder_statusTimeEnd') ||
                        '请选择最后一次状态时间'
                    "
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetime"
                    clearable
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_user') || '用户'">
              <dict-select
                v-model="form.listUserCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_user') || '请选择用户'"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reload">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const initForm = {
  keyword: '',
  listVersionStatus: ['N', 'Y', 'F'],
  listForceUpdate: [],
  listPlatform: [],
  listCreateBy: [],
  listModifyBy: [],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    //时间验证
    beginDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    processDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createBeginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createBeginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    modifyDatetimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    modifyDatetimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyBeginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyBeginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
